const $ = jQuery

export default class Hearings {
  ready () {
    function getHearings () {
      let hearings = document.getElementsByName('hearing-terms')
      return Array.from(hearings).filter(hearing => hearing.checked === true).map(function ($input){
        return $input['value'];
      })
    }


    const form = document.getElementById('hearing-notification-form')
    if(form) {
      form.addEventListener('submit', onSubmit)
    }

    function onSubmit (event) {
      event.preventDefault()
      let errorMessageContainer = document.getElementById('notification-error')
      let succesMessageContainer = document.getElementById('notification-succes')

      fetch(hearing_notification_object.signup_url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-WP-Nonce':  hearing_notification_object.rest_nonce
        },
        body: JSON.stringify({
          notification: {
            hearings: getHearings(),
            email: document.getElementById('emailField').value
          },
        })
      })
        .then((response) => response.json())
        .then((response) =>{
        if(! response.success){
          succesMessageContainer.style.display ='none'
          errorMessageContainer.style.display ='block'
          return response.data
        }
        succesMessageContainer.style.display ='block'
        errorMessageContainer.style.display ='none'

        return response.data})
    }

    }
}
